import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=2153ef19&scoped=true&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"
import style0 from "./Document.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Document.vue?vue&type=style&index=1&id=2153ef19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153ef19",
  null
  
)

export default component.exports